module.exports = __webpack_public_path__ + "static/media/bh.0dc78a04.svg";